import React from "react";
import styled from "styled-components";
import Modal from "@mui/material/Modal";
import BasicTitle from "./title";

const ModalCenter = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    max-width: 900px;
    background-color: #ffffff;
    padding: 40px;
    border-radius: 8px;
    overflow: visible;
    border: 1px solid rgb(144, 144, 144);
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.75);
`;

const ModalClose = styled.img`
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
`;

const Section = styled.div`
    margin-bottom: 12px;
`;

const Label = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 4px;
`;

const Text = styled.div`
    font-size: 14px;
    color: #333;
    line-height: 20px;
`;

const RestrictionsContainer = styled.div`
    display: flex;
    flex-direction: ${({ hasBoth }) => (hasBoth ? "row" : "column")};
    flex-wrap: wrap;
    gap: 24px;
    margin-top: 20px;
`;

const RestrictionBox = styled.div`
    flex: 1;
    background-color: #f6f6f6;
    padding: 24px;
    border-radius: 8px;
    margin-bottom: 10px;
`;

export default function ModalViewMessage({ open, close, data }) {
    if (!data) return null;

    const areaLabels = {
        // APP
        all_access_app: "ACESSO COMPLETO",
        new_refund_app: "SOLICITAR DESPESA",
        history_refund_app: "HISTÓRICO DE DESPESA",

        // ADMIN
        all_access_admin: "ACESSO COMPLETO",
        page_refunds_admin: "PÁGINA DE DESPESAS",
        export_admin: "GERAR PDF/EXPORTAR DESPESAS",
        page_users_admin: "PÁGINA DE USUÁRIOS",
        page_credits_admin: "PÁGINA DE CRÉDITOS",
        settings_admin: "CONFIGURAÇÕES",
    };

    const {
        platform,
        title,
        message,
        date,
        blocksArray,
        blockedAreas,
        companyId,
        companyName,
        onlyOwner,
    } = data;
    const safeBlocksArray = Array.isArray(blocksArray) ? blocksArray : [];
    const blockedApp = safeBlocksArray.filter((item) => item.endsWith("_app"));
    const blockedAdmin = safeBlocksArray.filter((item) =>
        item.endsWith("_admin")
    );

    return (
        <Modal open={open} onClose={close} aria-labelledby="modal-view-message">
            <ModalCenter>
                <ModalClose
                    src="/img/modal_close.svg"
                    alt="Fechar"
                    onClick={close}
                />
                <BasicTitle title="MENSAGEM" margin={26} />

                {companyId ? (
                    onlyOwner ? (
                        <Section
                            style={{
                                borderBottom: "1px solid #ccc",
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                flexWrap: "nowrap",
                            }}
                        >
                            <Text
                                style={{
                                    fontWeight: 600,
                                    marginBottom: 14,
                                    marginTop: 0,
                                }}
                            >
                                PARA:
                            </Text>
                            <Text
                                style={{
                                    backgroundColor: "#E4E4E4",
                                    padding: "4px 8px",
                                    borderRadius: "20px",
                                    display: "inline-block",
                                    fontWeight: 400,
                                    fontSize: 12,
                                    marginBottom: 14,
                                    textTransform: "uppercase",
                                }}
                            >
                                {companyName}
                            </Text>
                            <Text
                                style={{
                                    backgroundColor: "#E4E4E4",
                                    padding: "4px 8px",
                                    borderRadius: "20px",
                                    display: "inline-block",
                                    fontWeight: 400,
                                    fontSize: 12,
                                    marginBottom: 14,
                                }}
                            >
                                APENAS PROPRIETÁRIO
                            </Text>
                        </Section>
                    ) : (
                        <>
                            <Section>
                                <Text style={{ fontWeight: 600 }}>
                                    PLATAFORMA: {platform}
                                </Text>
                            </Section>

                            <Section
                                style={{
                                    borderBottom: "1px solid #ccc",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    flexWrap: "nowrap",
                                }}
                            >
                                <Text
                                    style={{
                                        fontWeight: 600,
                                        marginBottom: 14,
                                        marginTop: 0,
                                    }}
                                >
                                    PARA:
                                </Text>
                                <Text
                                    style={{
                                        backgroundColor: "#E4E4E4",
                                        padding: "4px 8px",
                                        borderRadius: "20px",
                                        display: "inline-block",
                                        fontWeight: 400,
                                        fontSize: 12,
                                        marginBottom: 14,
                                        textTransform: "uppercase",
                                    }}
                                >
                                    {companyName}
                                </Text>
                            </Section>
                        </>
                    )
                ) : (
                    <Section>
                        <Text style={{ fontWeight: 600 }}>
                            PLATAFORMA: {platform}
                        </Text>
                    </Section>
                )}

                <Section>
                    <Text style={{ color: "#419392", fontWeight: 600 }}>
                        {title}
                    </Text>
                </Section>

                <Section>
                    <Text>{date}</Text>
                </Section>

                <Section>
                    <Text style={{ fontWeight: 500 }}>{message}</Text>
                </Section>
                {blockedAreas === "SIM" && (
                    <Section style={{ marginTop: "40px" }}>
                        <Label>BLOQUEIO DE FUNCIONALIDADE</Label>

                        <RestrictionsContainer
                            hasBoth={
                                blockedApp.length > 0 && blockedAdmin.length > 0
                            }
                        >
                            {blockedApp.length > 0 && (
                                <RestrictionBox>
                                    <Text
                                        style={{
                                            fontWeight: 600,
                                            marginBottom: "10px",
                                        }}
                                    >
                                        APP
                                    </Text>
                                    {blockedApp.map((item, i) => (
                                        <Text
                                            style={{ marginBottom: 8 }}
                                            key={i}
                                        >
                                            {areaLabels[item] || item}
                                        </Text>
                                    ))}
                                </RestrictionBox>
                            )}

                            {blockedAdmin.length > 0 && (
                                <RestrictionBox>
                                    <Text
                                        style={{
                                            fontWeight: 600,
                                            marginBottom: "10px",
                                        }}
                                    >
                                        WEB ADMIN
                                    </Text>
                                    {blockedAdmin.map((item, i) => (
                                        <Text
                                            style={{ marginBottom: 8 }}
                                            key={i}
                                        >
                                            {areaLabels[item] || item}
                                        </Text>
                                    ))}
                                </RestrictionBox>
                            )}
                        </RestrictionsContainer>
                    </Section>
                )}
            </ModalCenter>
        </Modal>
    );
}
